import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddFileModal from './AddFileModal';
import FileRepositoryFileService from '../services/FileRepositoryFileService';

class AddFileModalContainer extends Component {
  static propTypes = {
    attachmentId: PropTypes.string 
  };

  render() {
    return (
      <AddFileModal
        isOpen={FileRepositoryFileService.isOpen}
        selectedAttachmentId={FileRepositoryFileService.selectedAttachmentId}
        onCancel={FileRepositoryFileService.handleClose}
        onSubmit={FileRepositoryFileService.handleSubmit}
        onReset={FileRepositoryFileService.form.reset}
        onChange={FileRepositoryFileService.form.setValue}
        values={FileRepositoryFileService.form.getValues()}
        errors={FileRepositoryFileService.form.errors}
        submitting={FileRepositoryFileService.fetch.fetching}
        isDirty={FileRepositoryFileService.form.isDirty}
      />
    );
  }
}

export default observer(AddFileModalContainer);
